// extracted by mini-css-extract-plugin
export var checkIcon = "_a-2";
export var heading = "_a-1";
export var panel = "_a-0";